angular
  .module("meanApp")
  .controller("futurePlansBeta-controller", function($scope, $stateParams,Auth) {
    "use strict";

    const reactContainerNode = document.getElementById("react-wrapper");
    Auth.isAdmin().then(isAdmin => ($scope.isAdmin = isAdmin));
    ReactDOM.render(
      React.createElement(FuturePlans.default, {
        id: $stateParams.clientId,
        url: process.env.API_ENDPOINT
      }),
      reactContainerNode
    );

    $scope.$on("$stateChangeStart", () => {
      ReactDOM.unmountComponentAtNode(reactContainerNode);
    });
  });
